import type * as ExcelJS from 'exceljs';

let exceljsPromise: Promise<typeof ExcelJS> | null = null;

/**
 * Asynchronously loads the ExcelJS library on demand.
 * WARNING: Please refrain from using this function and excelJS on new places on the FE.
 * It's ~900 KB and can be instead done through an API call on the BE
 */
export async function asyncLoadExceljs(): Promise<typeof ExcelJS> {
	if (!exceljsPromise) {
		exceljsPromise = import('exceljs');
	}
	return exceljsPromise;
}
